import * as actions from './actions';

const bookingTypeModule = {
  namespaced: true,
  actions,
};

export default bookingTypeModule;
